import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HisBackendService, GenericValue } from 'hisng';

@Injectable()
export class DocumentMetadataCategoryService {

    constructor( private backendService: HisBackendService ) { }

    /**
     * load documentMetadataCategoryValue for target object
     *
     * @param target reference object
     */
    public getDocumentMetadataCategories( target: string ): Observable<GenericValue[]> {
        return this.backendService.getData( `api/v1/fs/res/documentMetadataCategories/${target}` ) as Observable<GenericValue[]>;
    }

}
